import { render, staticRenderFns } from "./layout-green-screen.vue?vue&type=template&id=dc230376&scoped=true&"
import script from "./layout-green-screen.js?vue&type=script&lang=js&"
export * from "./layout-green-screen.js?vue&type=script&lang=js&"
import style0 from "./layout-green-screen.scss?vue&type=style&index=0&id=dc230376&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc230376",
  null
  
)

export default component.exports